import React, { useState, useEffect } from 'react';
import { getResponsesByFormId, getFormdataByFormId } from '../api/form'; 
import styles from './Response.module.css';

const Response = (props) => {
  const [responses, setResponses] = useState([]);
  const [formdatas, setFormdata] = useState([]);
  //const formId = "";
  

  useEffect(() => {
    if(props.reid!=='newform'){
      const formId = props.reid;
    const fetchResponses = async () => {
      try {
        const data = await getResponsesByFormId(formId);
        if (data && Array.isArray(data)) {
          setResponses(data);
        } else {
          setResponses([]);
          console.error('Unexpected data format:', data);
        }
      } catch (error) {
        console.error('Error fetching responses:', error);
        setResponses([]);
      }
    };

    const fetchFormdata = async () => {
      try {
        const data = await getFormdataByFormId(formId);
        if (data && Array.isArray(data.fields)) {
          setFormdata([data]);
        } else {
          setFormdata([]);
          console.error('Unexpected data format:', data);
        }
      } catch (error) {
        console.error('Error fetching form data:', error);
        setFormdata([]);
      }
    };

    fetchFormdata();
    fetchResponses();
  }
  }, [props.reid]);

  // Prepare dynamic headers and field IDs
  const excludedTypes = ['Image', 'Video', 'Gif', 'Text'];
  const allFieldTypes = [
    ...new Set(
      formdatas.flatMap(field =>
        field.fields?.filter(r => !excludedTypes.includes(r.type))
          .map(r => [r.id, r.type]) || []
      )
    )
  ];
  
  const totalRelevantFields = allFieldTypes.length;

  // Initialize the Field Type Counts Object
  const fieldTypeCounts = {};

  // Calculate the Field Types with Counts for Header Labels
  const allFieldTypes2 = allFieldTypes.map(([fieldId, fieldType]) => {
    if (!fieldTypeCounts[fieldType]) {
      fieldTypeCounts[fieldType] = 1;
    } else {
      fieldTypeCounts[fieldType] += 1;
    }
    return [fieldId, `${fieldType} ${fieldTypeCounts[fieldType]}`];
  });

  // Calculate Starts and Completions
  
  let completions = 0;

  responses.forEach(response => {
    // Calculate the number of filled fields in each response
    const filledFieldsCount = response.responses?.filter(
      r => !excludedTypes.includes(r.type) && r.value !== ''
    ).length || 0;
  
    //console.log("inner Count: " + filledFieldsCount);
    //console.log("Total Relevant Fields: " + totalRelevantFields);
  
    if (filledFieldsCount === totalRelevantFields) {
      completions++;
    }
  });
  //console.log("Filled Fields Count: " + completions);
  const starts = responses.length;
  const completionRate = responses.length > 0 ? (completions / starts) * 100 : 0;

  return (
    <>
      <div>
        {props.reid === 'newform' ? (
          <p className={styles.nulldata}>No Response yet collected</p>
        ) : (
          <>
            <div className={styles.views}>
              <h2>Views</h2>
              {formdatas.length > 0 && (
                <h2>{formdatas[0].views}</h2>
              )}
            </div>
            <div className={styles.Starts}>
              <h2>Starts</h2>
              <h2>{starts}</h2>
            </div>
            <div className={styles.Completionrate}>
              <h2>Completion Rate</h2>
              <h2>{completionRate.toFixed(2) + "%"}</h2>
            </div>
            <div className={styles.tableContainer}>
              <table className={styles.responseTable}>
                <thead>
                  <tr>
                    <th></th>
                    <th>Submitted At</th>
                    {allFieldTypes2.map(([fieldId, fieldTypeLabel]) => (
                      <th key={fieldId}>{fieldTypeLabel}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {responses.map((response, index) => (
                    <tr key={response._id}>
                      <td>{index + 1}</td>
                      <td>{new Date(response.submittedAt).toLocaleString()}</td>
                      {allFieldTypes.map(([fieldId]) => {
                        const fieldResponse = response.responses?.find(r => r.id.toString() === fieldId.toString());
                        return (
                          <td key={fieldId}>
                            {fieldResponse ? fieldResponse.value : ''}
                          </td>
                        );
                      })}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default Response;
